module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-layout"
  }, [_c('header', {
    staticClass: "app-header cf"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('a', {
    staticClass: "app-logo",
    attrs: {
      "href": "/home"
    }
  }, [_c('h1', [_vm._v("分享收客")])])])], 1)], 1)]), _vm._v(" "), _c('main', {
    staticClass: "app-main cf"
  }, [_c('router-view')], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_c('p', [_vm._v("Copyright(©) 2017 www.keketour.com 深圳市众游汇网络科技有限公司 All Rights Re")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://szcert.ebs.org.cn/CF52D6F1-F06A-4BEE-BD73-D7C41700F938",
      "target": "__blank"
    }
  }, [_c('img', {
    staticClass: "app-footer__",
    attrs: {
      "src": require("./img/bureau.jpg")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-5909aa8e!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
// module id = 221
// module chunks = 29